"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
    id: "prefix__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'alpha'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M21.498 4.358a1.45 1.45 0 0 1 .142 2.052L10.183 19.5a1.467 1.467 0 0 1-1.579.42 1.46 1.46 0 0 1-1.027-.592l-4.299-5.903a1.45 1.45 0 0 1 .326-2.032 1.466 1.466 0 0 1 2.041.324L9.04 16.38 19.437 4.5a1.466 1.466 0 0 1 2.062-.141Z",
      clipRule: "evenodd"
    })
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    mask: "url(#prefix__a)",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0 0h24v24H0z"
    })
  })]
});